<template>
    <v-card outlined rounded="lg" class="human-resource-item">
        <div class="pa-20 pa-md-24">
            <v-row align-lg="center" class="row--x-large">
                <v-col cols="12" lg="auto" class="mb-10 mb-lg-0">
                    <v-row align="center" class="row--x-large">
                        <v-col cols="auto">
                            <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                                <template #activator="{ active, toggle }">
                                    <v-btn icon text small :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                                        <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                    </v-btn>
                                </template>
                            </like-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-avatar color="grey">
                                        <v-img :src="value?.resume?.profile?.url">
                                            <v-fade-transition>
                                                <v-icon v-show="!value?.resume?.profile?.url" color="white">mdi-account</v-icon>
                                            </v-fade-transition>
                                        </v-img>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="auto">
                                    <v-layout align-center>
                                        <h5 class="page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px">
                                            {{ value?.resume?.personalInformation?.name }}
                                        </h5>
                                        <p class="page-text grey-9--text">
                                            ({{ value?.resume?.personalInformation?.genderText }}, {{ value?.resume?.personalInformation?.age }})
                                        </p>
                                    </v-layout>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="" class="recruit-list-item__detail mb-10 mb-lg-0">
                    <ul class="dot-texts">
                        <li v-for="text in cardTextList" :key="text" class="dot-text page-text grey-6--text ellip">
                            · {{ text }}
                        </li>
                    </ul>
                </v-col>
                <v-col cols="12" lg="auto">
                    <v-row class="row--small">
                        <v-col cols="10" lg="auto">
                            <v-btn outlined small color="primary" class="w-100 w-lg-100px" @click="showApplicationView(0)">지원자정보</v-btn>
                        </v-col>
                        <v-col cols="2" lg="auto">
                            <v-layout justify-center>
                                <v-btn icon outlined small color="grey-9" @click="showApplicationView(4)">
                                    <v-icon> mdi-checkbox-multiple-blank-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <application-view v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)" ref="application-view" />
    </v-card>
    <!-- <v-card outlined>
        <v-row class="ma-0 px-12" align="center">
            <v-col cols="auto">
                <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
            </v-col>
            <v-col cols="12" md="auto">
                <v-row class="ma-0" align="center">
                    <v-col cols="auto">
                        <v-avatar color="grey darken-1" size="30">
                            <v-img :src="value?.resume?.profile?.url">
                                <v-fade-transition>
                                    <v-icon v-show="!value?.resume?.profile?.url" color="white">mdi-account</v-icon>
                                </v-fade-transition>
                            </v-img>
                        </v-avatar>
                    </v-col>
                    <v-col cols="auto" class="page-text--lg"> {{ value?.resume?.personalInformation?.name }} </v-col>
                    <v-col cols="auto">
                        <span class="page-text--sm grey-9--text"> ({{ value?.resume?.personalInformation?.genderText }}, {{ value?.resume?.personalInformation?.age }}) </span>
                    </v-col>
                    <v-col cols="auto">
                        <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.USER_PERSON.value }">
                            <template #activator="{ active, toggle }">
                                <v-btn icon text small :color="active ? 'pink lighten-2' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                                    <v-icon small>{{ active ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
                                </v-btn>
                            </template>
                        </like-btn>
                        <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.BLACKLISTED.value }">
                            <template #activator="{ active, toggle }">
                                <v-btn icon text small :color="active ? 'red' : undefined" @click.stop.prevent.capture="toggle">
                                    <v-icon small>{{ active ? "mdi-account-cancel" : "mdi-account-cancel-outline" }}</v-icon>
                                </v-btn>
                            </template>
                        </like-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col>
                <v-row v-for="text in cardTextList" :key="text" no-gutters>
                    <v-col cols="auto"> <v-icon small color="grey lighten-1">mdi-circle-small</v-icon> </v-col> <v-col class="page-text grey-6--text">{{ text }}</v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="auto" class="pa-0 pa-12">
                <v-row align="center" class="ma-0 ma-n4">
                    <v-col cols="auto" class="pa-0 pa-4"> <v-btn color="primary" outlined @click="showApplicationView(0)">지원자정보</v-btn> </v-col>
                    <v-col class="pa-0 pa-4">
                        <v-btn outlined fab small icon @click="showApplicationView(4)">
                            <v-icon> mdi-checkbox-multiple-blank-outline </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <application-view v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)" ref="application-view" />
    </v-card> -->
</template>

<script>
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import ApplicationView from "../application/application-view.vue";

export default {
    components: {
        LikeBtn,
        ApplicationView,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        USER_LIKE_TYPES,
    }),
    computed: {
        area() {
            let { address1 } = this.value?.resume?.personalInformation?.residence || {};
            return address1
                .split(" ")
                .slice(0, 2)
                .join(" ");
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.resume?.personalInformation?.phone?.phoneNumberFormat?.(), this.area, this.education, `지원일: ${this.value?.appliedAt?.toDate?.()}`];
        },
    },
    methods: {
        showApplicationView(tab = 0) {
            const ref = this.$refs["application-view"];
            ref.$data.tab = tab;
            ref.$data.shows = true;
        },
    },
};
</script>

<style scoped>
.human-resource-item:not(:last-child){
    margin-bottom: 10px;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .human-resource-item:not(:last-child){
        margin-bottom: 20px;
    }
}
@media (min-width:1200px){
}

</style>
